:host {
  /**
   * @prop --color: Color of the card title
   */
  display: block;
  position: relative;
  color: var(--color);
}

:host(.ion-color) {
  color: var(--ion-color-base);
}

:host {
  --color: var(--ion-text-color, #000);
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}